














import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Icon from "@/components/Icon.vue";

@Component(
{
	components: {
		Icon
	}
})

export default class TranslationsLocaleSelector extends Vue
{
	@Prop() value!: string;
	@Prop() locales!: string[];

	@Watch("value")
	onValueChanged(val: string)
	{
		(this as any).model.value = val;
	}

	@Watch("locales")
	onLocalesChanged(val: string[])
	{
		(this as any).model.locales = val;
	}

	data()
	{
		return {
			model: {
				locales: this.locales,
				value: this.value,
			}
		};
	}

	onChange()
	{
		this.$emit("input", (this as any).model.value);
		this.$emit("change", (this as any).model.value);
		this.$emit("update:value", (this as any).model.value);
	}
}
